import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { NgHttpLoaderModule, Spinkit } from 'ng-http-loader';
import { SessionService } from './core/session/services/session.service';
import { StorageService } from './core/storage/services/storage.service';
import { TrackingService } from './core/tracking/services/tracking.service';
import { PlatformService } from './core/platform/services/platform.service';
import { UrlService } from './core/url/services/url.service';

const PARAM_KEY_DATA = 'data';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, NgHttpLoaderModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private _storage = inject(StorageService);
  private _platform = inject(PlatformService);
  private _session = inject(SessionService);
  private _tracking = inject(TrackingService);
  private _url = inject(UrlService);

  public establishmentName: string;
  public spinkit = Spinkit;

  ngOnInit() {
    // Continuar solo si estamos en el navegador.
    // Escapar si estamos en el servidor.
    if (this._platform.isServer()) {
      return;
    }

    this.establishmentName = this._storage.read('name');

    // Intentamos obtener el parametro "data"
    const data = this._url.getSearchParam(PARAM_KEY_DATA);

    // Si se obtiene el parametro "data" significa que
    // el usuario escaneo un qr.
    if (data) {
      const { code, uuid, name, carta_url } =
        this._url.getDecodedSearchParam(PARAM_KEY_DATA);

      // Si hubo un fallo en el escaneo:
      if (!code || !uuid || !name || !carta_url) {
        // 1. Registrar un error en el log.
        this._tracking.track('error-nocode-or-nouuid-or-noname', {
          table_code: code,
          establishment_uuid: uuid,
          date_event: new Date().toString(),
          user_agent: window.navigator.userAgent,
          session_start: this._storage.read('session_start'),
          data_param: this._url.getUrl(),
        });

        // 2. Terminar la sesión.
        this._session.end();

        // 3. No iniciamos ninguna sesión y detenemos todo el flujo.
        return;
      }

      // No hacer nada si la sesión está activa y el code es el mismo
      if (this._session.isAlive() && this._storage.read('code') === code) {
        // Detenemos todo el flujo.
        return;
      }

      // Hasta aqui "se escaneo correctamente" y la sesión ya no
      // está activa o nunca existió,
      // o es un nuevo "code", por lo tanto, debemos iniciar una
      // nueva sesión.

      // Iniciar una nueva sesión:

      console.log(
        'se guarda: "session_start", "code", "uuid", "name" y se elimina "cart-items"',
      );

      this._session.start();

      // Guardar el nuevo code, uuid y name en el storage (cookies o localstorage)
      this._storage.save('code', code);
      this._storage.save('uuid', uuid);
      this._storage.save('name', name);
      this._storage.save('carta_url', carta_url);

      // Limpiar el carrito
      this._storage.remove('cart-items');

      // TODO: Mejorar la manera en la que se
      // asigna establishmentName
      this.establishmentName = this._storage.read('name');

      // Google Analytics
      (window as any).dataLayer.push({
        event: 'initial-access',
        code: code,
        uuid: uuid,
        date: new Date().toString(),
        userAgent: window.navigator.userAgent,
      });

      // Pardos Analytics
      this._tracking.track('initial-access', {
        table_code: code,
        establishment_uuid: uuid,
        date_event: new Date().toString(),
        user_agent: window.navigator.userAgent,
        session_start: this._storage.read('session_start'),
      });
    }
  }
}
